import type { InsertNodesOptions, SlateEditor } from '@udecode/plate';

import { BaseImagePlugin } from '../BaseImagePlugin';
import { insertImage } from './insertImage';

export const insertImageFromFiles = (
    editor: SlateEditor,
    files: FileList,
    options: InsertNodesOptions = {}
) => {
    const uploadImage = editor.getOptions(BaseImagePlugin).uploadImage;

    if (!uploadImage) {
        return;
    }

    for (const file of files as unknown as Iterable<File>) {
        const [mime] = file.type.split('/');

        if (mime === 'image') {
            uploadImage(file).then((uploadedUrl) => {
                insertImage(editor, uploadedUrl, options);
            });
        }
    }
};
